import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";
import requestMiddlewares from "../../requestMiddlewares";

export default async function (
  dispatch: Dispatch,
  search: string,
): Promise<IResponse> {
  dispatch(startLoading());

  const request = new RACARequest('utils', 'findLocation')
    .setQueryParameters({
      search,
    })

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
